import React, { memo, useMemo } from 'react';
import Modal from '@components/common/Modal';
import { LABEL } from '@veriables';
import cn from 'classnames';
import styles from './actionConfirmationModal.module.scss';
import { TouchableButton } from '@components/common/Touchable';
import { connect } from 'react-redux';
import Loader from '@components/common/Loader/newLoaderModal';

const ActionConfirmationModal = ({ isOpen, onClose, customMessage, handleSubmit, loading, ...props }) => {
    const { serverAppTheme } = props; // Redux Imports

    const actionModal = useMemo(() => {
        const parentContainer = { color: serverAppTheme?.primary_text };
        const modal = {
            backgroundColor: serverAppTheme?.popUp_bg,
            borderRadius: '16px',
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
            width: '486px',
            margin: 'auto',
            minHeight: '216px',
            padding: '1.5rem',
            position: 'relative',
        };
        const noButton = {
            backgroundColor: serverAppTheme?.OFF_Premise_Btn,
            border: serverAppTheme?.cancleBtn_Border,
            color: serverAppTheme?.cancleBtn_font,
            borderRadius: '8px',
        };
        const yesButton = {
            backgroundColor: serverAppTheme?.secondaryBtn,
            color: serverAppTheme?.btn_font_color,
            borderRadius: '8px',
        };

        return {
            parentContainer,
            modal,
            noButton,
            yesButton,
        };
    }, [serverAppTheme]);

    return (
        <Modal
            isOpen={isOpen}
            isModalCenter
            style={actionModal.modal}
            customClass="h-100 w-100"
            customClass2="h-100 w-100"
            noBackground
        > 
        <>{loading && <Loader />}</>
            <div
                className="justify-content-center align-items-center text-center h-100"
                style={actionModal.parentContainer}
            >
                <div className="col-12 p-0 h-70 justify-content-center d-flex flex-column">
                    <div className="col-12 fs_18 fw-700 text-center h-auto">
                        Are You Sure ?
                    </div>
                    <br />
                    <div
                        className={cn('col-12 px-0 fs_15 fw-400 text-center h-auto')}
                    >
                        {customMessage}
                    </div>
                </div>
                <div
                    className={cn(
                        'col-12 px-4 h-30 d-flex mt-auto justify-content-center align-items-center text-center position-absolute',
                        styles.actionPopUpButtons
                    )}
                >
                    <div className="col-6 pl-0 pr-1">
                        <TouchableButton
                            type="submit"
                            className={cn(
                                styles.btnSecondary,
                                'col-12 fs_24 fw-600 btn-44'
                            )}
                            onClick={event => {
                                event.preventDefault();
                                onClose();
                            }}
                            style={actionModal.noButton}
                            rippleEffect={true}
                        >
                            {LABEL().NO}
                        </TouchableButton>
                    </div>
                    <div className="col-6 pl-1 pr-0">
                        <TouchableButton
                            type="submit"
                            className={cn(
                                styles.btnPrimary,
                                'col-12 btn-ripple fs_24 fw-600'
                            )}
                            onClick={event => {
                                event.preventDefault();
                                handleSubmit();
                            }}
                            style={actionModal.yesButton}
                            rippleEffect={true}
                        >
                            {LABEL().YES}
                        </TouchableButton>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

const mapStateToProps = ({ theme, orders }) => ({
    serverAppTheme: theme?.serverAppTheme,
    loading: orders.loading
})

const MemoizedActionConfirmationModal = memo(ActionConfirmationModal);

export default connect(mapStateToProps)(MemoizedActionConfirmationModal);